import { Fragment } from 'react';
import { isBoolean, isFunction, isString } from 'lodash/fp';
import { MenuItem } from './MenuItem.jsx';

export function MenuItems({ items = [], context }) {
    function renderItem({ label, icon, handler, disabled, when, id }) {
        if (isBoolean(when) && !when) {
            return null;
        }

        const renderedLabel = isFunction(label) ? label(context) : label;
        const itemId = isString(renderedLabel) ? `id-${renderedLabel}` : id;

        function handleClick() {
            handler(context);
        }

        return (
            <MenuItem
                key={itemId}
                icon={icon}
                label={renderedLabel}
                onClick={handleClick}
                disabled={disabled}
            />
        );
    }

    return <Fragment>{items.map(renderItem)}</Fragment>;
}
